//
import Service from '@/services/api/service'
import CustomerReceivablePaymentModel from '@/models/POS/PosCustomerReceivablePayment'

//
import appends  from './appends'
import fields   from './fields'
import headers  from './headers'
import includes from './includes'
import print    from './print'

//
export default class extends Service {

    //
    static appends  = appends
    static fields   = fields
    static headers  = headers
    static includes = includes
    static print    = print
    
    //
    static model = CustomerReceivablePaymentModel
}
